import { ReactElement } from 'react';

export const PDPBannerPromoDefaultIcon = (): ReactElement => {
    return (
        <svg
            width='17'
            height='16'
            viewBox='0 0 17 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_2647_1830)'>
                <path
                    d='M7.44479 0.642353C8.17043 -0.214118 9.49141 -0.214118 10.2171 0.642353C10.662 1.16755 11.3656 1.39616 12.0343 1.23281C13.1248 0.966433 14.1935 1.74289 14.2771 2.86231C14.3284 3.54875 14.7632 4.14726 15.4002 4.40815C16.439 4.83361 16.8472 6.08995 16.2569 7.04473C15.8949 7.63022 15.8949 8.37001 16.2569 8.9555C16.8472 9.91029 16.439 11.1666 15.4002 11.5921C14.7632 11.853 14.3284 12.4515 14.2771 13.1379C14.1935 14.2573 13.1248 15.0338 12.0343 14.7674C11.3656 14.6041 10.662 14.8327 10.2171 15.3579C9.49141 16.2144 8.17043 16.2144 7.44479 15.3579C6.99982 14.8327 6.29623 14.6041 5.62754 14.7674C4.53706 15.0338 3.46836 14.2573 3.38473 13.1379C3.33345 12.4515 2.89861 11.853 2.26161 11.5921C1.22282 11.1666 0.814614 9.91029 1.40493 8.9555C1.76692 8.37001 1.76692 7.63022 1.40493 7.04473C0.814614 6.08995 1.22282 4.83361 2.26161 4.40815C2.89861 4.14726 3.33345 3.54875 3.38473 2.86231C3.46836 1.74289 4.53706 0.966433 5.62754 1.23281C6.29623 1.39616 6.99982 1.16755 7.44479 0.642353Z'
                    fill='#EF5DA8'
                />
                <path
                    d='M8.0188 6.98951C7.6855 7.30893 7.28275 7.46864 6.81057 7.46864C6.33839 7.46864 5.93564 7.30893 5.60234 6.98951C5.27597 6.6701 5.11279 6.28124 5.11279 5.82294C5.11279 5.37159 5.27945 4.98621 5.61275 4.66679C5.94606 4.34043 6.34533 4.17725 6.81057 4.17725C7.27581 4.17725 7.67508 4.34043 8.00839 4.66679C8.34864 4.98621 8.51876 5.37159 8.51876 5.82294C8.51876 6.28124 8.35211 6.6701 8.0188 6.98951ZM5.37319 11.6975L11.0498 4.30224H12.2684L6.59184 11.6975H5.37319ZM6.32103 6.31249C6.45296 6.44442 6.61614 6.51039 6.81057 6.51039C7.005 6.51039 7.16818 6.44442 7.30011 6.31249C7.43899 6.18055 7.50843 6.01737 7.50843 5.82294C7.50843 5.63546 7.43899 5.47575 7.30011 5.34382C7.16818 5.20494 7.005 5.1355 6.81057 5.1355C6.61614 5.1355 6.45296 5.20494 6.32103 5.34382C6.18909 5.47575 6.12313 5.63546 6.12313 5.82294C6.12313 6.01737 6.18909 6.18055 6.32103 6.31249ZM9.64367 11.3433C9.31731 11.0239 9.15413 10.6385 9.15413 10.1872C9.15413 9.73581 9.31731 9.35043 9.64367 9.03101C9.97697 8.70465 10.3797 8.54147 10.8519 8.54147C11.3171 8.54147 11.7164 8.70465 12.0497 9.03101C12.383 9.35043 12.5497 9.73581 12.5497 10.1872C12.5497 10.6385 12.383 11.0239 12.0497 11.3433C11.7234 11.6627 11.3241 11.8224 10.8519 11.8224C10.3797 11.8224 9.97697 11.6627 9.64367 11.3433ZM10.1645 10.1767C10.1645 10.3712 10.2304 10.5344 10.3624 10.6663C10.4943 10.7982 10.6575 10.8642 10.8519 10.8642C11.0463 10.8642 11.2095 10.7982 11.3414 10.6663C11.4803 10.5344 11.5498 10.3712 11.5498 10.1767C11.5498 9.98926 11.4803 9.82956 11.3414 9.69762C11.2095 9.55874 11.0463 9.48931 10.8519 9.48931C10.6575 9.48931 10.4943 9.55874 10.3624 9.69762C10.2304 9.82956 10.1645 9.98926 10.1645 10.1767Z'
                    fill='white'
                />
            </g>
            <defs>
                <clipPath id='clip0_2647_1830'>
                    <rect
                        width='16'
                        height='16'
                        fill='white'
                        transform='translate(0.831055)'
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const PDPBannerPromoPaymentIcon = (): ReactElement => {
    return (
        <svg
            width='17'
            height='16'
            viewBox='0 0 17 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_2648_35657)'>
                <rect
                    x='1.26123'
                    y='1.0835'
                    width='12.1846'
                    height='3.63782'
                    fill='white'
                />
                <rect
                    x='6.77539'
                    y='7.12769'
                    width='8.09668'
                    height='4.93896'
                    fill='white'
                />
                <path
                    d='M0.279297 1.94604V12.9731C0.279297 13.7185 0.575435 14.4335 1.10256 14.9606C1.62969 15.4877 2.34463 15.7839 3.09011 15.7839H13.4685C14.214 15.7839 14.9289 15.4877 15.456 14.9606C15.9832 14.4335 16.2793 13.7185 16.2793 12.9731V5.62171C16.2793 4.98896 16.0658 4.37471 15.6735 3.87829C15.2811 3.38187 14.7328 3.03232 14.1171 2.88615V2.16225C14.1171 1.90671 14.0668 1.65367 13.969 1.41757C13.8712 1.18148 13.7279 0.966961 13.5472 0.786263C13.3665 0.605565 13.152 0.462228 12.9159 0.364435C12.6798 0.266642 12.4267 0.216309 12.1712 0.216309H2.22524C1.74659 0.216323 1.28474 0.392747 0.927982 0.711852C0.571224 1.03096 0.344588 1.47035 0.291405 1.94604H0.279297ZM2.22524 2.8109C2.05321 2.8109 1.88822 2.74256 1.76658 2.62092C1.64493 2.49927 1.57659 2.33429 1.57659 2.16225C1.57659 1.99022 1.64493 1.82524 1.76658 1.70359C1.88822 1.58195 2.05321 1.51361 2.22524 1.51361H12.1712C12.3432 1.51361 12.5082 1.58195 12.6299 1.70359C12.7515 1.82524 12.8198 1.99022 12.8198 2.16225V2.8109H2.22524ZM11.7388 8.86496H13.4685C13.6405 8.86496 13.8055 8.9333 13.9272 9.05494C14.0488 9.17659 14.1171 9.34157 14.1171 9.51361C14.1171 9.68564 14.0488 9.85062 13.9272 9.97227C13.8055 10.0939 13.6405 10.1623 13.4685 10.1623H11.7388C11.5667 10.1623 11.4017 10.0939 11.2801 9.97227C11.1584 9.85062 11.0901 9.68564 11.0901 9.51361C11.0901 9.34157 11.1584 9.17659 11.2801 9.05494C11.4017 8.9333 11.5667 8.86496 11.7388 8.86496Z'
                    fill='#EF5DA8'
                />
            </g>
            <defs>
                <clipPath id='clip0_2648_35657'>
                    <rect
                        width='16'
                        height='16'
                        fill='white'
                        transform='translate(0.279297)'
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
export const PDPBannerPromoFreeIcon = (): ReactElement => {
    return (
        <svg
            width='35'
            height='16'
            viewBox='0 0 35 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect
                x='0.279297'
                width='34.4443'
                height='16'
                rx='2'
                fill='#EF5DA8'
            />
            <path
                d='M25.4316 12.26V3.73999H30.5316V5.07199H26.9796V7.30399H29.8476V8.63599H26.9796V10.928H30.7236V12.26H25.4316Z'
                fill='white'
            />
            <path
                d='M18.5293 12.26V3.73999H23.6293V5.07199H20.0773V7.30399H22.9453V8.63599H20.0773V10.928H23.8213V12.26H18.5293Z'
                fill='white'
            />
            <path
                d='M10.6309 12.26V3.73999H13.3789C14.1709 3.73999 14.7429 3.81999 15.0949 3.97999C15.5269 4.17999 15.8669 4.47999 16.1149 4.87999C16.3629 5.27999 16.4869 5.75599 16.4869 6.30799C16.4869 6.82799 16.3549 7.30399 16.0909 7.73599C15.8349 8.15999 15.4869 8.45999 15.0469 8.63599V8.65999C15.1269 8.73999 15.2229 8.87999 15.3349 9.07999L17.0869 12.26H15.3589L13.6669 9.07999H12.1789V12.26H10.6309ZM12.1789 7.73599H13.5709C13.9869 7.73599 14.3149 7.61999 14.5549 7.38799C14.7949 7.14799 14.9149 6.81599 14.9149 6.39199C14.9149 5.95199 14.7989 5.62399 14.5669 5.40799C14.3349 5.18399 13.9309 5.07199 13.3549 5.07199H12.1789V7.73599Z'
                fill='white'
            />
            <path
                d='M4.2793 12.26V3.73999H9.1753V5.07199H5.8273V7.48399H8.6473V8.81599H5.8273V12.26H4.2793Z'
                fill='white'
            />
        </svg>
    );
};

export const PDPBannerPromoBonusIcon = (): ReactElement => {
    return (
        <svg
            width='17'
            height='16'
            viewBox='0 0 17 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect x='0.279297' width='16' height='16' rx='2' fill='#EF5DA8' />
            <path
                d='M3.22656 7.68433V12.737C3.22656 13.072 3.35964 13.3933 3.59653 13.6301C3.83342 13.867 4.15471 14.0001 4.48972 14.0001H12.0687C12.4037 14.0001 12.725 13.867 12.9619 13.6301C13.1987 13.3933 13.3318 13.072 13.3318 12.737V7.68433'
                stroke='white'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M8.27922 4.21053C8.27922 3.62426 8.04633 3.062 7.63177 2.64745C7.21722 2.23289 6.65496 2 6.06869 2C5.64993 2 5.24832 2.16635 4.95221 2.46246C4.6561 2.75857 4.48975 3.16018 4.48975 3.57895C4.48975 3.99771 4.6561 4.39932 4.95221 4.69543C5.24832 4.99154 5.64993 5.15789 6.06869 5.15789H8.27922M8.27922 4.21053V5.15789M8.27922 4.21053C8.27922 3.62426 8.51211 3.062 8.92667 2.64745C9.34122 2.23289 9.90348 2 10.4897 2C10.9085 2 11.3101 2.16635 11.6062 2.46246C11.9023 2.75857 12.0687 3.16018 12.0687 3.57895C12.0687 3.7863 12.0279 3.99162 11.9485 4.18318C11.8692 4.37475 11.7528 4.54881 11.6062 4.69543C11.4596 4.84205 11.2855 4.95836 11.094 5.0377C10.9024 5.11705 10.6971 5.15789 10.4897 5.15789H8.27922'
                stroke='white'
                strokeLinejoin='round'
            />
            <path
                d='M8.27943 7.68427V14.0001M2.59521 5.15796H13.9636V7.68427H2.59521V5.15796Z'
                stroke='white'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export const PDPBannerPromoDiscountIcon = (): ReactElement => {
    return (
        <svg
            width='17'
            height='16'
            viewBox='0 0 17 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_2648_35642)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M13.6746 2.04585C13.5069 1.677 13.1392 1.44019 12.734 1.44019L1.31249 1.44018C0.741873 1.44018 0.279298 1.90276 0.279298 2.47337L0.279298 13.527C0.279298 14.0976 0.741873 14.5602 1.31249 14.5602L12.734 14.5602C13.1392 14.5602 13.5069 14.3234 13.6746 13.9545L16.1867 8.4277C16.3102 8.15606 16.3102 7.84429 16.1867 7.57265L13.6746 2.04585ZM13.8924 8.00054C13.8924 8.4115 14.2255 8.74466 14.6365 8.74466C15.0475 8.74466 15.3806 8.4115 15.3806 8.00054C15.3806 7.58957 15.0475 7.25642 14.6365 7.25642C14.2255 7.25642 13.8924 7.58957 13.8924 8.00054Z'
                    fill='#EF5DA8'
                />
                <path
                    d='M6.36183 6.95663C6.01747 7.28665 5.60136 7.45166 5.1135 7.45166C4.62565 7.45166 4.20953 7.28665 3.86517 6.95663C3.52797 6.62661 3.35938 6.22485 3.35938 5.75134C3.35938 5.28501 3.53156 4.88684 3.87593 4.55682C4.2203 4.21962 4.63282 4.05103 5.1135 4.05103C5.59418 4.05103 6.0067 4.21962 6.35107 4.55682C6.70262 4.88684 6.87839 5.28501 6.87839 5.75134C6.87839 6.22485 6.7062 6.62661 6.36183 6.95663ZM3.62841 11.8208L9.49343 4.18016H10.7525L4.88751 11.8208H3.62841ZM4.60771 6.25713C4.74402 6.39345 4.91262 6.4616 5.1135 6.4616C5.31438 6.4616 5.48298 6.39345 5.61929 6.25713C5.76278 6.12082 5.83452 5.95222 5.83452 5.75134C5.83452 5.55764 5.76278 5.39263 5.61929 5.25631C5.48298 5.11283 5.31438 5.04108 5.1135 5.04108C4.91262 5.04108 4.74402 5.11283 4.60771 5.25631C4.4714 5.39263 4.40324 5.55764 4.40324 5.75134C4.40324 5.95222 4.4714 6.12082 4.60771 6.25713ZM8.04063 11.4549C7.70344 11.1249 7.53484 10.7267 7.53484 10.2604C7.53484 9.79408 7.70344 9.39591 8.04063 9.06589C8.385 8.72869 8.80111 8.5601 9.28896 8.5601C9.76964 8.5601 10.1822 8.72869 10.5265 9.06589C10.8709 9.39591 11.0431 9.79408 11.0431 10.2604C11.0431 10.7267 10.8709 11.1249 10.5265 11.4549C10.1893 11.785 9.77682 11.95 9.28896 11.95C8.80111 11.95 8.385 11.785 8.04063 11.4549ZM8.5787 10.2497C8.5787 10.4505 8.64686 10.6191 8.78317 10.7554C8.91949 10.8918 9.08808 10.9599 9.28896 10.9599C9.48985 10.9599 9.65844 10.8918 9.79475 10.7554C9.93824 10.6191 10.01 10.4505 10.01 10.2497C10.01 10.0559 9.93824 9.89093 9.79475 9.75462C9.65844 9.61114 9.48985 9.53939 9.28896 9.53939C9.08808 9.53939 8.91949 9.61114 8.78317 9.75462C8.64686 9.89093 8.5787 10.0559 8.5787 10.2497Z'
                    fill='white'
                />
            </g>
            <defs>
                <clipPath id='clip0_2648_35642'>
                    <rect
                        width='16'
                        height='16'
                        fill='white'
                        transform='translate(0.279297)'
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const PDPBannerPromoLeftBadgeIcon = (): ReactElement => {
    return (
        <div className='promo-badge__left'>
            <svg
                width='6'
                height='24'
                viewBox='0 0 6 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M2.83105 0C1.72649 0 0.831055 0.89543 0.831055 2V7C3.59249 7 5.83105 9.23858 5.83105 12C5.83105 14.7614 3.59249 17 0.831055 17V22C0.831055 23.1046 1.72649 24 2.83105 24H5.83105V12V0H2.83105Z'
                    fill='black'
                    fillOpacity='0.4'
                />
            </svg>
        </div>
    );
};

export const PDPBannerPromoRightBadgeIcon = (): ReactElement => {
    return (
        <div className='promo-badge__right -ml-[1px]'>
            <svg
                width='6'
                height='24'
                viewBox='0 0 6 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M3.83105 0H0.831055V12V24H3.83105C4.93562 24 5.83105 23.1046 5.83105 22V17C3.06962 17 0.831055 14.7614 0.831055 12C0.831055 9.23858 3.06962 7 5.83105 7V2C5.83105 0.895431 4.93562 0 3.83105 0Z'
                    fill='black'
                    fillOpacity='0.4'
                />
            </svg>
        </div>
    );
};
